import { forwardRef, HTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

export type FeaturedIconOutlineSize = "sm" | "md" | "lg" | "xl";
export type FeaturedIconOutlineColor = "brand" | "gray" | "success" | "warning" | "error";

export type FeaturedIconOutlineProps = HTMLAttributes<HTMLDivElement> & {
  size?: FeaturedIconOutlineSize
  color?: FeaturedIconOutlineColor
};
export const FeaturedIconOutline = memo(forwardRef<HTMLDivElement, FeaturedIconOutlineProps>((
  {
    size = "md",
    children,
    color = "gray",
    className,
    ...props
  }, ref) => {
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        styles[size],
        styles[color],
      )}
    >
      {children}
    </div>
  );
}));